import {
  LoadingContainer,
  LegacyPage,
  Model,
  Panels,
  Bar,
  Button,
} from 'peach/components'
import { useParams, useRouteMatch, useHistory } from 'peach/router'

import { useServicesGetAll } from 'core/types'

const MonitoringServices = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()

  const { data: services, isLoading } = useServicesGetAll({
    companyId,
  })

  const createButton = (
    <Button onClick={() => history.push(`${url}/create`)} primary>
      Create Service
    </Button>
  )

  return (
    <Panels header={<Bar right={createButton} title='Monitoring Services' />}>
      <LoadingContainer isLoading={isLoading}>
        <LegacyPage.Full>
          <Model.List
            json={services ?? []}
            title='Monitoring Services'
            withDetails
            withRelated
            withTimestamps
          />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default MonitoringServices
